import React, { useEffect, useState } from 'react';
import { Templates } from '@Assets/SvgIcons/Templates';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import { Checkbox } from '@mui/material';
import './FileItem.component.scss';
import PopupContent from '@components/Popups/PopupContent/PopupContent.component';
import { FileActionMenuItem } from '../FolderView/FileActionMenuItems';
import FileItemMenu from '../FileActionMenu/FileActionMenu.component';
import { useNavigate } from 'react-router-dom';
import { RouteEnums } from '@Helper/Enums';
import { getPersonalTemplatesDetail } from '@Store/feature/personalTemplatesDetailSlice';
import { useAppSelector } from '@Store/hooks';

export type FileItemProps = {
  createdAt?: string;
  projectId?: string;
  updatedAt?: string;
  id?: string;
  templateId?: string;
  name: string;
  htmlName?: string;
  type?: string;
  isOdd: boolean;
  description?: string;
  copiedTo?: string;
  contains?: string;
  copied?: Copied[];
  files: FileItemProps[];
  path?: string;
  handleOnPathClicked: (folder: FileItemProps) => void;
  actionMenuItems: FileActionMenuItem[];
  onActionMenuItemClick?: (file: FileItemProps, action: string) => void;
  onChangeChecked?: (file: FileItemProps, checked: boolean) => void;
};

export type Copied = {
  playbookId: string;
  playbookName: string;
  dealspaceId: string;
  dealspaceName: string;
};

type FileIcons = {
  file: JSX.Element;
  folder: JSX.Element;
};

const FileIcon = (type: string = 'file'): JSX.Element => {
  const fileIcons: FileIcons = {
    file: <Templates color={'#9997AF'} width={'26.67'} height={'21.33'} />,
    folder: (
      <FolderOutlinedIcon style={{ fontSize: '26.67px', color: '#9997AF' }} />
    ),
  };
  return fileIcons[type as keyof FileIcons];
};

const getPopUpContent = (copiedList: Copied[]) => {
  return (
    <PopupContent
      element={
        <div className="file-item-view__field__work-streams">
          {copiedList.length} workstreams
        </div>
      }
      contentElement={
        <ul className="file-item-view__work-streams">
          {copiedList.map(
            ({ playbookId, playbookName, dealspaceName }, index) => (
              <li
                className="file-item-view__work-streams__item"
                key={`${index}-${playbookId}`}
              >
                {playbookName} <span> ({dealspaceName}) </span>
              </li>
            )
          )}
        </ul>
      }
    />
  );
};

const FileItem = (file: FileItemProps) => {
  const {
    name,
    htmlName,
    id,
    isOdd,
    description,
    type = 'file',
    createdAt,
    updatedAt,
    handleOnPathClicked,
    actionMenuItems,
    onActionMenuItemClick,
    onChangeChecked,
    contains = '0',
    copied = [],
  } = file;
  const isFolder = type !== 'file';
  const navigate = useNavigate();
  const [fileName, setfileName] = useState<string>('');
  const [checked, setChecked] = useState<boolean>(false);
  const { files } = useAppSelector(getPersonalTemplatesDetail);
  console.log('file', file);
  console.log('name', name);

  useEffect(() => {
    if (!isFolder) {
      setfileName(name ?? files?.find(i => i.id === id)?.name ?? '');
    }
  }, [getPersonalTemplatesDetail, name]);

  const handleChangeChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setChecked(checked);
    type === 'file' && onChangeChecked && onChangeChecked(file, checked);
  };

  const onPathClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isFolder) {
      return;
    }

    handleOnPathClicked(file);
  };

  const handleActionClick = (action: string) => {
    onActionMenuItemClick && onActionMenuItemClick(file, action);
  };

  const getFormattedDate = (date: string) => {
    const dateTime = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(dateTime);
  };

  const filteredActionMenuItems = actionMenuItems.filter(
    ({ hideOn = [] }) => !hideOn.includes(type)
  );

  return (
    <div
      className={`file-item-view ${isOdd ? 'is-odd' : ''}`}
      onDoubleClick={() => {
        //navigate
        if (!isFolder) {
          navigate(RouteEnums.PersonalTemplatesDetail + file.templateId);
        }
      }}
    >
      <div className="file-item-view__icon">
        {!isFolder && (
          <Checkbox
            checked={checked}
            onChange={handleChangeChecked}
            icon={
              <CheckCircleOutlineOutlined
                style={{ fontSize: '20px', color: '#9997AF' }}
              />
            }
            checkedIcon={
              <CheckCircleIcon style={{ fontSize: '20px', color: '#5D54C0' }} />
            }
          />
        )}
      </div>
      <div className="file-item-view__icon">{FileIcon(type)}</div>
      <div className="file-item-view__details" onClick={onPathClick}>
        <div
          className="file-item-view__details__name"
          dangerouslySetInnerHTML={{
            __html: isFolder ? htmlName ?? name ?? '' : fileName,
          }}
        />
        {description && (
          <div className="file-item-view__details__description">
            {description}
          </div>
        )}
      </div>
      <div className="file-item-view__field">
        {copied.length > 0 && getPopUpContent(copied)}
        {copied.length === 0 && (
          <div className="file-item-view__field__work-streams">
            {copied.length} workstreams
          </div>
        )}
      </div>
      <div className="file-item-view__field">{contains} items</div>
      <div className="file-item-view__field">
        {(updatedAt || createdAt) &&
          getFormattedDate(updatedAt ?? createdAt ?? '')}
      </div>
      <div className="file-item-view__field">
        <FileItemMenu
          icon={
            <MoreHorizOutlinedIcon
              style={{ fontSize: '24px', color: '#7D7A9A' }}
            />
          }
          items={filteredActionMenuItems}
          handleActionClick={handleActionClick}
        />
      </div>
    </div>
  );
};

export default FileItem;
